import { LongueurStation } from './longueur-station';

export class MesureStation {
    id: number;
    processId: number;
    LongueurStations: LongueurStation[] = [];
    LmMoyenne: number;
    LtTheorique: number;
    LtReelle: number;

    static mapFromJSON(json: any): MesureStation {
        const m = new MesureStation();

        if (json.longueurStations) {
            m.LongueurStations = json.longueurStations.map(jsonItem => LongueurStation.mapFromJSON(jsonItem));
        }

        m.LmMoyenne = json.lmMoyenne;
        m.LtTheorique = json.ltTheorique;
        m.LtReelle = json.ltReelle;

        return m;
    }
}
